import gql from 'graphql-tag'

const DeleteJourney = gql`
  mutation deleteJourney($id: Int!) {
    deleteJourney(input: { id: $id }) {
      success
      error
      journey {
        id
        name
        active
        campaignEmails {
          id
          name
          updatedAt
          createdAt
          type
          siteId
          status
          state
          screenshotUrl
          previewUrl
          sendAtInTimezone
        }
      }
    }
  }
`

const DuplicateJourney = gql`
  mutation duplicateJourney($input: DuplicateJourney!) {
    duplicateJourney(input:$input) {
      success
      error
      journey {
        id
        name
        active
        campaignFolderId
        campaignEmails {
          id
          name
          updatedAt
          createdAt
          type
          siteId
          status
          state
          screenshotUrl
          previewUrl
          sendAtInTimezone
        }
      }
    }
  }
`
const DeleteJourneyEmailStep = gql`
  mutation deleteJourneyEmailStep($id: Int!, $emailId: Int!) {
    deleteJourneyEmailStep(input: { id: $id, emailId: $emailId }) {
      success
      journey {
        id
        name
        active
        campaignEmails {
          id
          name
          updatedAt
          createdAt
          type
          siteId
          status
          state
          screenshotUrl
          previewUrl
          sendAtInTimezone
        }
      }
    }
  }
`

const UpdateJourney = gql`
  mutation updateJourney($id: Int!, $name: String, $active: Boolean, $campaignFolderId: Int, $isLocked: Boolean) {
    updateJourney(input: { id: $id, name:$name, active:$active, campaignFolderId: $campaignFolderId, isLocked: $isLocked }){
      success
      error
      journey {
        id
        name
        active
        stopMode
        campaignFolderId
        isLocked
      }
    }
  }
`

const StopJourney = gql`
  mutation stopJourney($id: Int!, $outcome: JourneyStopOutcome!) {
    stopJourney(input: { id: $id, outcome: $outcome }) {
      success
      error
      journey {
        id
        name
        active
        stopMode
      }
    }
  }
`

const UpdateJourneyEmailStep = gql`
  mutation updateJourneyEmailStep($id: Int!, $emailId: Int!, $delayInterval: Int!, $delayPeriod: String!) {
    updateJourneyEmailStep(input: { id: $id, emailId: $emailId, delayInterval: $delayInterval, delayPeriod: $delayPeriod }) {
      error
      success
      journey {
        id
        name
        active
        campaignEmails {
          id
          name
          updatedAt
          createdAt
          type
          siteId
          status
          state
          screenshotUrl
          previewUrl
          sendAtInTimezone
        }
      }
      email {
        id
        delayInterval
        delayPeriod
      }
    }
  }
`



const CanCreateEmailJourney = gql`
  mutation canCreateEmailJourney ($siteId: Int!, $isAutomation: Boolean) {
    canCreateEmailJourney(input: { siteId: $siteId, isAutomation: $isAutomation}) {
      success
      error
    }
  }
`

const CreateAutomationJourney = gql`
  mutation createAutomationJourney($input: CreateJourney!) {
    createAutomationJourney(input: $input) {
      success
      error
      journey {
        id
        name
        active
        campaignEmails {
          id
          name
          updatedAt
          createdAt
          type
          siteId
          status
          state
          screenshotUrl
          previewUrl
          sendAtInTimezone
        }
      }
    }
  }
`

const CreateEmailJourney = gql`
  mutation createEmailJourney($siteId: Int!) {
    createEmailJourney(input: { siteId: $siteId }) {
      success
      error
      journey {
        id
        name
        active
        campaignEmails {
          id
          name
          updatedAt
          createdAt
          type
          siteId
          status
          state
          screenshotUrl
          previewUrl
          sendAtInTimezone
        }
      }
    }
  }
`
const CreateJourneyEmailStep = gql`
  mutation createJourneyEmailStep($id: Int!) {
    createJourneyEmailStep(input: { id: $id }) {
      success
      error
      journey {
        id
        name
        active
        campaignEmails {
          id
          name
          updatedAt
          createdAt
          type
          siteId
          status
          state
          screenshotUrl
          previewUrl
          sendAtInTimezone
        }
      }
      email {
        id
      }
    }
  }
`

const UpdateJourneyStep = gql`
  mutation UpdateJourneyStep($stepId: Int!, $conditions: JSON, $delayInterval: Int, $delayPeriod: String) {
    updateJourneyStep(input: { stepId: $stepId, conditions: $conditions, delayInterval: $delayInterval, delayPeriod: $delayPeriod }) {
      success
      error
      journey {
        id
        name
        active
        journeySteps {
          id
          action
          trueJourneyStepId
          falseJourneyStepId
          conditions
          metaData
          journeyId
        }
      }
    }
  }
`;

export { 
  CanCreateEmailJourney, 
  CreateEmailJourney, 
  CreateAutomationJourney, 
  CreateJourneyEmailStep, 
  DeleteJourney, 
  DeleteJourneyEmailStep, 
  UpdateJourney, 
  StopJourney,
  UpdateJourneyEmailStep, 
  UpdateJourneyStep, 
  DuplicateJourney,
}